import { Row, Col, Icon, Button } from 'antd';
import { HomeCaptchaForm, RegistrationStatus } from '@bit/ui-common.ui-components/ss-components';

class StepStatusIndicator extends React.Component {
    constructor(props) { super(props); }

    static getStepConfig= t => { switch(t) {
        case 'dodPersonalInformation': return { title: 'Personal', icon: 'user', no: 2 };
        case 'dodOfficeAddress': return { title: 'DoD Attaché', icon: 'environment', no: 3 };
        case 'dodCredentials': return { title: 'ID & Email', icon: 'idcard', no: 4 };
        case 'dodSecurity': return { title: 'Security', icon: 'lock', no: 5 };
        case 'dodAuth': return { title: 'Authorization', icon: 'edit', no: 6 };
        default: return { title: null, icon: null, no: 0 };
    }}

    render() {
        const 
        { valid, step, goToStep } = this.props,
        stepData = StepStatusIndicator.getStepConfig(step),
        { title, icon, no } = stepData;
        return (
            <Col span={4}>
                {!valid ? (
                    <div className='home-cand-reg-step-status-indicator-text-error'>
                        <Icon type='close-circle' style={{ marginRight: '6px' }} />
                        {'Incomplete'}
                    </div>
                ) : (
                    <div className='home-cand-reg-step-status-indicator-text-completed'>
                        <Icon type='check-circle' style={{ marginRight: '6px' }} />
                        {'Completed'}
                    </div>
                )}
                <div className={!valid
                    ? 'home-cand-reg-step-status-indicator-error'
                    : 'home-cand-reg-step-status-indicator-success'
                } onClick={() => goToStep(no)}>
                    <Icon type={icon} style={{ marginRight: '8px' }} />
                    <div className='home-cand-reg-step-status-indicator-title'>
                        {title}
                    </div>
                </div>
            </Col>
        );
    }
}

export default class DodReview extends React.Component {

    state = {
        showAcknowledgement: false,
        captchaInput: ''
    };

    constructor(props) { 
        super(props);
        this.updateCaptchaField = this.updateCaptchaField.bind(this);
    }

    componentDidMount() {
        this.loadCaptcha();
    }

    componentWillUnmount() {
        const { services } = this.props;
        services.resetCaptchaValidation();
    }

    static goToStep(controls, step) {
        const { changeStep } = controls.layout;
        changeStep(null, step - 1);
    }

    loadCaptcha() {
        const { dodReviewLoadCaptcha } = this.props.services;
        dodReviewLoadCaptcha();
    }

    hasDesigneeLetter() {
        const { designeeLetter } = this.props.state.authorization.forms;
        if (designeeLetter.hasOwnProperty('letter')) return { valid: true, value: designeeLetter.letter };
        else return { valid: false, value: null };
    }

    updateCaptchaField(e){
        const
        { services } = this.props,
        value = e.target.value;
        if(this.state.captchaInput.length !== 8 && value.length === 8){
            services.checkCaptcha(value);
        }
        this.setState((state,props) => {
            return {...state, 
                    captchaFormProps: {...state.captchaFormProps, field:value},
                    captchaInput: value
                     }
           });
    }

    generateStepStats = form => {
        let status = { valid: null, steps: {}};

        for (let s in form) {
            let step = form[s];
            for (let f in step) 
                if (f !== 'id') {
                    let field;

                    if (f.indexOf('_') !== -1) field = f.substring(0, f.indexOf('_'));
                    else field = f;

                    if (!status.steps.hasOwnProperty(s)) status.steps[s] = { valid: null };
                    if (!status.steps[s].hasOwnProperty(field)) status.steps[s][field] = {
                        valid: step[`${field}_status`] === 'success' ? true : false,
                        value: step[field]
                    }
                }

            if (s === 'dodAuth' && !status.steps[s].hasOwnProperty('letter')) 
                status.steps[s].letter = this.hasDesigneeLetter();

            for (let p in status.steps[s])
                if (p !== 'valid' && !status.steps[s][p].valid) {
                    status.steps[s].valid = false;
                    break;
                }

            if (status.steps[s].valid == null) 
                status.steps[s].valid = true;
        }

        for (let s in status.steps)
            if (s !== 'valid' && !status.steps[s].valid) {
                status.valid = false;
                break;
            }

        if (status.valid == null)
            status.valid = true;
        
        return status;
    }

    render() {
        const 
        { registrationForm, controls, captcha, services, state } = this.props,
        { request } = state.review.submission,
        { letter } = state.authorization.forms.designeeLetter,
        status = this.generateStepStats(registrationForm),
        captcahStatus = captcha.validation.status,
        regStatus = request.status,
        regCode = request.code,
        {captchaInput} = this.state;

        return (
            <div>
                <RegistrationStatus 
                    type='dod' 
                    status={regStatus !== 'pending' && regStatus !== 'success' ? regCode : regStatus}
                    visible={regStatus != null}
                    failureCallback={code => { 
                        services.resetCaptchaValidation();
                        services.dodReviewSubmitReset();
                        switch(code) {
                            case 409:
                                services.markFieldErrorCode(409, 'dodCredentials', 'emailAddress');
                                DodReview.goToStep(controls, 4);
                                break;

                            case 410: 
                                services.markFieldErrorCode(409, 'dodCredentials', 'emailAddress');
                                services.markFieldErrorCode(412, 'dodCredentials', 'userId');
                                DodReview.goToStep(controls, 4);
                                break;

                            case 412:
                                services.markFieldErrorCode(412, 'dodCredentials', 'userId');
                                DodReview.goToStep(controls, 4);
                                break;

                            default: window.location.href = setEnvPrefix('/home');
                        }
                    }}
                />
                <Row type='flex' justify='space-around' align='middle' style={{ marginBottom: '45px' }}>
                    <Col span={21}>
                        <Row type='flex' justify='space-around' align='middle' gutter={10}>
                            {Object.keys(status.steps).map((step, i) => <StepStatusIndicator
                                goToStep={step => DodReview.goToStep(controls, step)}
                                valid={status.steps[step].valid}
                                step={step}
                                key={i}
                            />)}
                        </Row>
                    </Col>
                </Row>
                <Row type='flex' justify='space-around' align='middle'>
                    <Col span={21}>
                        <Row type='flex' justify='space-around' align='middle'>
                            <Col>
                                <div style={!status.valid ? { filter: 'grayscale(100%) blur(2px)' } : {}}>
                                    <HomeCaptchaForm
                                        state={captcha}
                                        updateCaptchaField={this.updateCaptchaField}
                                        captchaInput={captchaInput}
                                        services={services}
                                    />
                                </div>
                                {status.valid ? null : (
                                    <div>
                                        <div className='home-cand-reg-captcha-mask' />
                                        <div className='home-cand-reg-captcha-mask-message' style={{ width: '558px' }}>
                                            <Icon type='warning' style={{ marginRight: '8px' }} />
                                            {'Verification code is unavailable until all required information is completed.'}
                                        </div>
                                    </div>
                                )}
                            </Col>
                        </Row>
                        <Row type='flex' justify='space-around' align='middle'>
                            <Col>
                                <Button
                                    type='primary'
                                    icon='check-circle'
                                    disabled={captcahStatus === 'success' && status.valid ? false : true}
                                    style={{ width: '241px', borderRadius: '20px' }}
                                    onClick={() => services.dodReviewSubmit(registrationForm, letter, captchaInput)}
                                >
                                    {'Submit'}
                                </Button>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </div>
        );
    }
}